const RenderField = ({ field, value, onChange }) => {
  const sintomaData = field.Sintoma || field;
  const { json_definicion } = sintomaData;
  const Nombre = sintomaData.Nombre || sintomaData.NombreSintoma;
  const definicion =
    typeof json_definicion === "object" && json_definicion !== null
      ? json_definicion
      : JSON.parse(json_definicion || "{}");
  const { tipo, configuracion } = definicion;
  console.log('RenderField render', field.IdSintoma, tipo, configuracion);
  const normalizedValue = value ?? '';

  const handleInputChange = (e) => {
    const { type, checked, value } = e.target;
    let newVal = type === 'checkbox' ? checked : value;
    
    // Si es un campo numérico, convertir a número
    if (tipo === 'numerico' && value !== '' && value !== null) {
      newVal = parseFloat(value);
    }
    
    console.log('RenderField input change', field.IdSintoma, newVal, 'tipo:', typeof newVal);
    onChange(field.IdSintoma, newVal);
  };

  const handleMultipleChange = (option) => {
    const currentValue = Array.isArray(value) ? value : [];
    const newValue = currentValue.includes(option)
      ? currentValue.filter(item => item !== option)
            : [...currentValue, option];
    console.log('RenderField multiple change', field.IdSintoma, newValue);
    onChange(field.IdSintoma, newValue);
  };

  const renderInput = () => {
    switch (tipo) {
      case 'booleano':
        return (
          <div className="seguimiento-checkbox">
            <input
              type="checkbox"
              id={`sintoma-${field.IdSintoma}`}
              checked={!!value}
              onChange={handleInputChange}
            />
            <span>{Nombre}</span>
          </div>
        );
      case 'texto':
        return (
          <div className="seguimiento-field">
            <label htmlFor={`sintoma-${field.IdSintoma}`}>{Nombre}</label>
            <input
              type="text"
              id={`sintoma-${field.IdSintoma}`}
              value={normalizedValue}
              onChange={handleInputChange}
              maxLength={configuracion?.maxLength}
              className="seguimiento-input"
            />
          </div>
        );
      case 'numerico':
        return (
          <div className="seguimiento-field">
            <label htmlFor={`sintoma-${field.IdSintoma}`}>{Nombre}</label>
            <input
              type="number"
              id={`sintoma-${field.IdSintoma}`}
              value={normalizedValue}
              onChange={handleInputChange}
              min={configuracion?.minimo}
              max={configuracion?.maximo}
              className="seguimiento-input"
            />
             {configuracion?.unidad && <span> {configuracion.unidad}</span>}
          </div>
        );
      case 'fecha':
        return (
          <div className="seguimiento-field">
            <label htmlFor={`sintoma-${field.IdSintoma}`}>{Nombre}</label>
            <input
              type="date"
              id={`sintoma-${field.IdSintoma}`}
              value={normalizedValue}
              onChange={handleInputChange}
              className="seguimiento-input"
            />
          </div>
        );
      case 'seleccion':
        return (
          <div className="seguimiento-field">
            <label htmlFor={`sintoma-${field.IdSintoma}`}>{Nombre}</label>
            <select
              id={`sintoma-${field.IdSintoma}`}
              value={normalizedValue}
              onChange={handleInputChange}
              className="seguimiento-select"
            >
              <option value="">Seleccione...</option>
              {configuracion?.opciones?.map(op => <option key={op} value={op}>{op}</option>)}
            </select>
          </div>
        );
      case 'multiple':
        return (
          <div className="seguimiento-field">
            <label>{Nombre}</label>
            {configuracion?.opciones?.map(op => (
              <div key={op} className="seguimiento-checkbox">
                <input
                  type="checkbox"
                  id={`sintoma-${field.IdSintoma}-${op}`}
                  checked={Array.isArray(value) && value.includes(op)}
                  onChange={() => handleMultipleChange(op)}
                />
                <span>{op}</span>
              </div>
            ))}
          </div>
        );
      case 'duracion':
        return (
          <div className="seguimiento-field">
            <label htmlFor={`sintoma-${field.IdSintoma}`}>{Nombre}</label>
            <input
              type="number"
              id={`sintoma-${field.IdSintoma}`}
              value={normalizedValue}
              onChange={handleInputChange}
              min="0"
              className="seguimiento-input"
            />
            {configuracion?.unidadTiempo && <span> {configuracion.unidadTiempo}</span>}
          </div>
        );
      case 'compuesto':
        const valorCompuesto = typeof value === 'object' && value !== null ? value : {};
        return (
          <div className="seguimiento-field">
            <label>{Nombre}</label>
            <div style={{ paddingLeft: '10px', borderLeft: '2px solid #ddd' }}>
              {(configuracion?.subcampos || []).map((subcampo, index) => {
                const subcampoId = `${field.IdSintoma}_${index}`;
                const subcampoValue = valorCompuesto[subcampo.etiqueta] ?? '';
                
                const handleSubcampoChange = (e) => {
                  const nuevoValor = {
                    ...valorCompuesto,
                    [subcampo.etiqueta]: e.target.value
                  };
                  onChange(field.IdSintoma, nuevoValor);
                };

                return (
                  <div key={subcampoId} className={subcampo.tipo !== 'booleano' ? 'seguimiento-field' : ''} style={{ marginBottom: '8px' }}>
                    {subcampo.tipo !== 'booleano' && (
                      <label htmlFor={subcampoId} style={{ fontSize: '0.9em' }}>
                        {subcampo.etiqueta}
                      </label>
                    )}
                    {subcampo.tipo === 'numerico' && (
                      <input
                        type="number"
                        id={subcampoId}
                        value={subcampoValue}
                        onChange={handleSubcampoChange}
                        className="seguimiento-input"
                      />
                    )}
                    {subcampo.tipo === 'texto' && (
                      <input
                        type="text"
                        id={subcampoId}
                        value={subcampoValue}
                        onChange={handleSubcampoChange}
                        className="seguimiento-input"
                      />
                    )}
                    {subcampo.tipo === 'fecha' && (
                      <input
                        type="date"
                        id={subcampoId}
                        value={subcampoValue}
                        onChange={handleSubcampoChange}
                        className="seguimiento-input"
                      />
                    )}
                    {subcampo.tipo === 'booleano' && (
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <input
                          type="checkbox"
                          id={subcampoId}
                          checked={!!valorCompuesto[subcampo.etiqueta]}
                          onChange={(e) => {
                            const nuevoValor = {
                              ...valorCompuesto,
                              [subcampo.etiqueta]: e.target.checked
                            };
                            onChange(field.IdSintoma, nuevoValor);
                          }}
                        />
                        <label htmlFor={subcampoId} style={{ fontSize: '0.9em', margin: 0, cursor: 'pointer' }}>
                          {subcampo.etiqueta}
                        </label>
                      </div>
                    )}
                    {subcampo.tipo === 'seleccion' && (
                      <select
                        id={subcampoId}
                        value={subcampoValue}
                        onChange={handleSubcampoChange}
                        className="seguimiento-select"
                      >
                        <option value="">Seleccione...</option>
                        {(subcampo.opciones || []).map(op => (
                          <option key={op} value={op}>{op}</option>
                        ))}
                      </select>
                    )}
                    {subcampo.tipo === 'multiple' && (
                      (subcampo.opciones || []).map(op => {
                        const arr = Array.isArray(valorCompuesto[subcampo.etiqueta]) ? valorCompuesto[subcampo.etiqueta] : [];
                        return (
                          <div key={op} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <input
                              type="checkbox"
                              id={`${subcampoId}_${op}`}
                              checked={arr.includes(op)}
                              onChange={(e) => {
                                const currentArr = Array.isArray(valorCompuesto[subcampo.etiqueta]) ? valorCompuesto[subcampo.etiqueta] : [];
                                const newArr = e.target.checked
                                  ? [...currentArr, op]
                                  : currentArr.filter(x => x !== op);
                                onChange(field.IdSintoma, { ...valorCompuesto, [subcampo.etiqueta]: newArr });
                              }}
                            />
                            <label htmlFor={`${subcampoId}_${op}`} style={{ fontSize: '0.9em', margin: 0 }}>{op}</label>
                          </div>
                        );
                      })
                    )}
                    {subcampo.tipo === 'duracion' && (
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <input
                          type="number"
                          id={subcampoId}
                          value={subcampoValue}
                          onChange={handleSubcampoChange}
                          min="0"
                          className="seguimiento-input"
                        />
                        {subcampo.unidadTiempo && <span>{subcampo.unidadTiempo}</span>}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        );
      default:
        return <p>Tipo de campo no soportado: {tipo}</p>;
    }
  };

  return (
    <div className="dynamic-field-container">
      {renderInput()}
    </div>
  );
};

export default RenderField;
